/*
All material copyright ESRI, All Rights Reserved, unless otherwise specified.
See https://js.arcgis.com/4.33/esri/copyright.txt for details.
*/
import e from"./FeatureReferenceGlobalId.js";import r from"./FeatureReferenceId.js";import t from"./FeatureReferenceObjectId.js";const o={key:"type",base:r,typeMap:{"object-id":t,"global-id":e}};export{o as featureReferenceIdType};
